import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

interface SVGProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
}

const WarningHex: React.FC<SVGProps> = (props) => {
  const { isDarkMode } = useContext(ThemeContext);
  const { width, height, fill } = props;

  const finalColor = fill?.trim() ? fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132E";
  return (
    <svg
      width={width ?? 45}
      height={height ?? 41}
      viewBox="0 0 45 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: finalColor }}
      {...props}
    >
      <path
        d="M20.7948 22.0117L20.7948 9.47144L24.2041 9.47144L24.2041 22.0117C24.2041 22.7836 23.4404 23.4089 22.4995 23.4089C21.5586 23.4089 20.7948 22.7836 20.7948 22.0117Z"
        fill="currentColor"
      />
      <path
        d="M20.2774 29.3015L20.2774 26.7358L22.4995 25.4535L24.7227 26.7358L24.7227 29.3015L22.4995 30.5862L20.2774 29.3015Z"
        fill="currentColor"
      />
      <path
        d="M14.6954 37.2417L14.686 37.2417L14.5722 37.2394C13.1702 37.2276 11.8551 36.4686 11.1418 35.2578L3.37292 22.0712C2.63029 20.8112 2.63029 19.245 3.37292 17.9838L11.1406 4.79717C11.8621 3.57354 13.1913 2.81331 14.6097 2.81331L30.3891 2.81331C31.8087 2.81331 33.1379 3.57354 33.8582 4.796L37.1256 10.3417L41.6271 17.9826C42.3697 19.2426 42.3697 20.8089 41.6271 22.07L33.8582 35.2578C33.1379 36.4815 31.8075 37.2417 30.3891 37.2417L14.6954 37.2417ZM14.6109 40.0574L30.3891 40.0574C32.8129 40.0574 35.0549 38.7751 36.2844 36.688L44.0532 23.5013C45.3156 21.3579 45.3156 18.6995 44.0532 16.556L39.5517 8.91506L36.2844 3.3694C35.0549 1.2823 32.8129 2.8686e-06 30.3891 2.6567e-06L14.6109 1.27732e-06C12.1871 1.06543e-06 9.94513 1.2823 8.71563 3.3694L0.946768 16.556C-0.315584 18.6995 -0.315584 21.3591 0.946767 23.5013L8.71562 36.688C9.93574 38.7575 12.1484 40.0362 14.5487 40.055C14.5698 40.0574 14.5898 40.0574 14.6109 40.0574Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default WarningHex;
